interface Props {
  className?: string;
}

const Skeleton = ({ className }: Props) => {
  return (
    <div className={`bg-skeleton-dark animate-pulse rounded-md ${className}`}></div>
  );
};

export default Skeleton;
